interface customFolder extends Record<string, any> {
  name: string;
  children?: customFolder[];
  coordinates: number[];
  path: string;
  type: string;
}

// Iterative Folder‑Tree Builder (No Recursion)
function buildFoldersTree(
  segregatedRootFolder: string[][]
): customFolder {
  const rootName = segregatedRootFolder[0][0];

  const root: customFolder = {
    name: rootName,
    type: 'folder',
    children: [],
    coordinates: [0, 0],
    path: rootName
  };

  // Fast lookup: path → folder node
  const folderMap = new Map<string, customFolder>();
  folderMap.set(rootName, root);

  for (let row = 0; row < segregatedRootFolder.length; row++) {
    const parts = segregatedRootFolder[row];

    let currentPath = '';
    let parent: customFolder = root;

    for (let col = 0; col < parts.length; col++) {
      const name = parts[col];
      currentPath = col === 0 ? name : currentPath + '/' + name;

      const isLast = col === parts.length - 1;

      // If folder/file already exists, reuse it
      let existing = folderMap.get(currentPath);

      if (existing) {
        parent = existing;
        continue;
      }

      if (isLast) {
        // Create file
        const fileNode: any = {
          name,
          type: 'file',
          coordinates: [row, col],
          path: currentPath
        };

        parent.children?.push(fileNode);
      } else {
        // Create folder
        const folderNode: customFolder = {
          name,
          type: 'folder',
          children: [],
          coordinates: [row, col],
          path: currentPath
        };

        parent.children?.push(folderNode);
        folderMap.set(currentPath, folderNode);
        parent = folderNode;
      }
    }
  }

  return root;
}

export default buildFoldersTree;
